import React from 'react';

import cn from '~/utils/cn';

export type size = 'sm' | 'md' | 'lg' | 'xl' | '2xl';
const SIZE_CLASSES: Record<size, string> = {
  sm: 'h-8 w-8',
  md: 'h-16 w-16',
  lg: 'h-32 w-32',
  xl: 'h-40 w-40',
  '2xl': 'h-80 w-80',
};

interface CliveAvatarProps {
  className?: string;
  size?: size;
}

const CliveAvatar: React.FC<CliveAvatarProps> = ({ className, size = 'lg' }) => (
  <div
    className={cn('bg-clive-avatar shrink-0 bg-cover', SIZE_CLASSES[size], className)}
    role="img"
    aria-label="Clive avatar"
  />
);

export default CliveAvatar;
